<template>
  <div class="courseCategory-box">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>科目类别字典</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" size="small" :model="searchData" class="user-search">
      <el-form-item label="名称：">
        <el-input size="small" v-model="searchData.courseCategoryName" placeholder="请输入名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select clearable v-model="searchData.stateSign">
          <el-option label="全部" :value="null"></el-option>
          <el-option label="启用" :value="true"></el-option>
          <el-option label="停用" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleSearch()">查询</el-button>
        <el-button v-buttonAuth="'system:classification:add'" size="small" type="primary"
          @click="handleAddAndEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">
      <!--      <el-table-column align="center"  prop="userSex" label="状态" min-width="50">-->
      <!--      </el-table-column>-->
      <el-table-column prop="userSex" label="操作">
        <template slot-scope="scope">
          <el-button v-buttonAuth="'system:classification:edit'" size="mini" type="primary"
            @click="handleAddAndEdit(scope.$index, scope.row)">编辑</el-button>
          <el-popconfirm title="是否删除数据？" @confirm="handleRemove(scope.$index, scope.row)">
            <template #reference>
              <el-button v-buttonAuth="'system:classification:delete'" size="mini" type="danger"
                class="mg-lef10">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
    <!-- 编辑界面 -->
    <el-dialog :title="dialogData.title" :visible.sync="dialogData.visible" width="30%">
      <my-form ref="editForm" :form-config="dialogData.commonList" :dataForm="dialogData.form"
        :formRules="dialogData.rules" />
      <div slot="footer" class="dialog-footer text-rgt">
        <el-button size="small" @click='dialogData.visible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="dialogData.loading" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import api from '../../api/onlineTraining/classification';
export default {
  components: {
    MyTable,
    Pagination,
    myForm
  },
  data () {
    return {
      searchData: {}, //  搜索参数
      customColumns: [
        // { label: '序号', prop: 'age' },
        { label: '编码', prop: 'courseCategoryCode' },
        { label: '名称', prop: 'courseCategoryName' },
        { label: '状态', prop: 'stateSign', formatter: data => data ? '启用' : '停用' }
      ],
      isLoading: false,
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
      dialogData: {
        title: '',
        visible: false,
        loading: false,
        commonList: [
          // { type: 'input', prop: 'num', label: '分类编码', placeholder: '请输入分类编码' },
          { type: 'input', prop: 'courseCategoryName', label: '类别名称', placeholder: '请输入类别名称' },
          { type: 'select', prop: 'stateSign', label: '状态', options: [{ id: true, label: '启用' }, { id: false, label: '停用' }] },
        ],
        form: {},
        rules: {
          // num: { required: true, message: '请输入分类编码', trigger: 'blur' },
          courseCategoryName: { required: true, message: '请输入类别名称', trigger: 'blur' },
          stateSign: { required: true, message: '请选择状态', trigger: 'change' },
        }
      } //  弹窗
    }
  },
  created () {
    this.getData();
  },
  methods: {
    //  改变分页及大小
    callFather (data) {
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      const params = {
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
        courseCategoryName: this.searchData.courseCategoryName,
        stateSign: this.searchData.stateSign
      };
      const res = await api.courseCategoryPage(params);
      this.tableData = res.data.records;
      this.pageInfo.total = res.data.total;
    },
    //  搜索
    handleSearch () {
      this.pageInfo.currentPage = 1;
      this.getData();
    },
    //  打开添加/编辑弹窗
    handleAddAndEdit (index, row) {
      this.dialogData.commonList[0].disable = !!row;
      if (row) {
        this.dialogData.form = row;
      } else this.dialogData.form = {};
      this.dialogData.title = index ? '编辑' : '添加';
      this.dialogData.visible = true;
    },
    //  删除选中项
    async handleRemove (index, row) {
      const res = await api.courseCategoryRemove([row.courseCategoryId]);
      this.tableData.splice(index, 1);
      this.$message({ message: '删除成功', type: 'success' });
    },
    //  提交
    submitForm (editData) {
      this.$refs.editForm.$refs.form.validate(async valid => {
        if (!valid) return false;
        // 请求方法
        const url = this.dialogData.form.courseCategoryId ? 'courseCategoryEdit' : 'courseCategoryAdd';
        const res = await api[url](this.dialogData.form);
        this.$message({ message: this.dialogData.form.courseCategoryId ? '编辑成功' : '添加成功', type: 'success' });
        this.dialogData.visible = false;
        await this.getData();
      });
    },
    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    }
  }
}
</script>

<style lang="scss" scoped>
.courseCategory-box {
  height: 100%;
}

.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/classification.vue